import { render } from "./Quizs.vue?vue&type=template&id=3fb8898d&scoped=true"
import script from "./Quizs.vue?vue&type=script&lang=js"
export * from "./Quizs.vue?vue&type=script&lang=js"

import "./Quizs.vue?vue&type=style&index=0&id=3fb8898d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb8898d"]])

export default __exports__